import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { SettingsProvider } from './contexts/SettingsContext';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'services/graphql';
import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/css/sass/themes/greenlime.scss';
import App from './App';
import * as Sentry from "@sentry/react";
import { MenuProvider } from 'contexts/MenuContext';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false
    }),
    Sentry.captureConsoleIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/ark\.greensteps\.me/],
  // Session Replay
  replaysSessionSampleRate: 0.001,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <SettingsProvider>
      <ApolloProvider client={apolloClient}>
        <MenuProvider>
          <Suspense fallback={<div className="loading" />}>
            <App />
          </Suspense>
        </MenuProvider>
      </ApolloProvider>
    </SettingsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your ark to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
